import React, { useState, useEffect } from 'react';
import styles from './Services.module.css';

const Services = () => {
    const [services, setServices] = useState([]);
    const [settings, setSettings] = useState({
        title: 'Услуги',
        showTitle: true,
        columns: 3,
        gap: 30
    });
    const [loading, setLoading] = useState(true);
    const [selectedService, setSelectedService] = useState(null);
    const [consent, setConsent] = useState(false);
    const [date, setDate] = useState('');

    // Telegram ссылка (замените на вашу)
    const TELEGRAM_LINK = "https://t.me/lozovskaya_tanya";

    useEffect(() => {
        loadServices();
    }, []);

    const loadServices = async () => {
        try {
            const [servicesRes, settingsRes] = await Promise.all([
                fetch('/api/content/services?field=items'),
                fetch('/api/content/services?field=settings')
            ]);

            const servicesData = await servicesRes.json();
            const settingsData = await settingsRes.json();

            let allServices = servicesData.data || [];
            allServices.sort((a, b) => (a.order || 0) - (b.order || 0));

            setServices(allServices.filter(s => s.visible));
            setSettings(settingsData.data || { title: 'Услуги', showTitle: true, columns: 3, gap: 30 });
        } catch (error) {
            console.error('Ошибка загрузки услуг:', error);
        } finally {
            setLoading(false);
        }
    };

    const openModal = (service) => {
        setSelectedService(service);
        setConsent(false);
        setDate('');
        document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
        setSelectedService(null);
        document.body.style.overflow = 'auto';
    };

    const handleSubmit = () => {
        if (!consent) return;

        // Формируем сообщение
        const dateText = date ? ` на ${date}` : '';
        const messageText = `Добрый день, мне необходима услуга "${selectedService.name}"${dateText}`;
        const encodedMessage = encodeURIComponent(messageText);

        // Убираем @ из ника если есть
        const telegramLink = TELEGRAM_LINK.replace('@', '');

        // Открываем Telegram
        window.open(`${telegramLink}?text=${encodedMessage}`, '_blank');

        closeModal();
    };

    if (loading || services.length === 0) return null;

    return (
        <>
            <section id="services" className={styles.services}>
                <div className={styles.container}>
                    {settings.showTitle && (
                        <h2 className={styles.title}>{settings.title}</h2>
                    )}

                    <div
                        className={styles.grid}
                        style={{
                            display: 'grid',
                            gridTemplateColumns: `repeat(${settings.columns || 3}, 1fr)`,
                            gap: `${settings.gap || 30}px`
                        }}
                    >
                        {services.map((service) => (
                            <div key={service.id} className={styles.serviceCard}>
                                <div className={styles.imageWrapper}>
                                    {service.imageUrl ? (
                                        <img
                                            src={`${service.imageUrl}`}
                                            alt={service.name}
                                            className={styles.image}
                                        />
                                    ) : (
                                        <div className={styles.placeholder}>💄</div>
                                    )}
                                </div>
                                <h3 className={styles.serviceName}>{service.name}</h3>
                                <div className={styles.price}>{service.price.toLocaleString()} ₽</div>
                                <button
                                    className={styles.bookBtn}
                                    onClick={() => openModal(service)}
                                >
                                    Записаться
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className={styles.notice}>
                <p>Выезд к клиенту — 4000 ₽ дополнительно</p>
            </div>

            {/* Модальное окно */}
            {selectedService && (
                <div className={styles.modalOverlay} onClick={closeModal}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.closeBtn} onClick={closeModal}>✕</button>

                        <div className={styles.modalBody}>
                            <div className={styles.modalImage}>
                                {selectedService.imageUrl ? (
                                    <img src={`${selectedService.imageUrl}`} alt={selectedService.name} />
                                ) : (
                                    <div className={styles.modalPlaceholder}>💄</div>
                                )}
                            </div>

                            <div className={styles.modalInfo}>
                                <h3>{selectedService.name}</h3>
                                <div className={styles.modalDuration}>⏱️ {selectedService.duration}</div>
                                <div className={styles.modalPrice}>{selectedService.price.toLocaleString()} ₽</div>
                                <div className={styles.modalDescription}>{selectedService.description}</div>

                                <div className={styles.modalForm}>
                                    <input
                                        type="date"
                                        value={date}
                                        onChange={(e) => setDate(e.target.value)}
                                        className={styles.formInput}
                                        min={new Date().toISOString().split('T')[0]}
                                        placeholder="Выберите дату"
                                    />

                                    <label className={styles.checkboxLabel}>
                                        <input
                                            type="checkbox"
                                            checked={consent}
                                            onChange={(e) => setConsent(e.target.checked)}
                                        />
                                        <span>Продолжая, вы соглашаетесь с обработкой персональных данных</span>
                                    </label>

                                    <button
                                        className={styles.submitBtn}
                                        disabled={!consent}
                                        onClick={handleSubmit}
                                    >
                                        Отправить заявку
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Services;